import { toInteger } from 'lodash';

export const OTHER_PAYMENT_METHODS = 'other_payment_methods';

export const ONE_TIME = 'one_time';

export const RECURRING = 'recurring';

export const GATEWAY_TYPE = 'gateway_type';

export const RECURRING_GATEWAY_TYPE = 'recurring_gateway_type';

export const DEFAULT_PRICE_VALUES = {
	period: null,
	price: null,
	promotions: null
};

export const TRANSACTION_TYPES = {
	PURCHASE: 'purchase',
	RENT: 'rent',
	SUBSCRIPTION: 'subscription'
} as const;

export const SUBSCRIPTION_STATUS_TYPES = {
	ACTIVE: 'active',
	CANCELED: 'canceled',
	PENDING: 'pending'
};

export const GATEWAY_TYPES = {
	CARD: 'card',
	CARD_RECURRING: 'card_recurring',
	BLIK: 'blik',
	BLIK_RECURRING: 'blik_recurring',
	GOOGLE_PAY: 'google_pay',
	GOOGLE_PAY_RECURRING: 'google_pay_recurring',
	APPLE_PAY: 'apple_pay',
	APPLE_PAYRECURRING: 'apple_pay_recurring',
	OTHER_BLUEMEDIA: 'other_bluemedia',
	UNKNOWN: 'unknown'
};

export const PAYMENT_METHODS = {
	INVOICE: 'invoice',
	CARD: 'card',
	EXTERNAL: 'external',
	BLUEMEDIA: 'bluemedia',
	SUBSCRIPTION_BLUEMEDIA: 'subscription_bluemedia',
	APPSTORE: 'appstore',
	GOOGLEPLAY: 'googleplay',
	SUBSCRIPTION_APPSTORE: 'subscription_appstore',
	SUBSCRIPTION_GOOGLEPLAY: 'subscription_googleplay'
} as const;

export const NO_AUTH_PAYMENT_METHODS = [PAYMENT_METHODS.BLUEMEDIA, PAYMENT_METHODS.SUBSCRIPTION_BLUEMEDIA];

export const isNumber = (value: any) => typeof value === 'number';

export const PAYMENT_ACTIVATION = 'payment_activation';

// TO DO - this function should be deleted from:
// src/components/views/configurator/helpers/prices.js
export const convertPriceToReadableFormat = (value?: number | null) => {
	if (!value) return '0,00';
	const newValue = (value * 0.01).toFixed(2);
	return newValue.toString().replace('.', ',');
};

export const convertPriceToNumberFormat = (value?: number | null) => {
	if (!value) return 0;
	return parseFloat((value * 0.01).toFixed(2));
};

export const convertStringToNumber = (value: string) => {
	const numberValue = parseFloat(value.replace(',', '.'));
	return isNaN(numberValue) ? 0 : numberValue;
};

export const getDurationInMonths = (duration: number | undefined) => {
	if (!duration || duration <= 0) return 0;
	return toInteger(duration / 30);
};
